export default "__VITE_ASSET__BSMOo1rM__"